export interface EmptyStateMessage {
  title: string
  description?: string
}

export const emptyStateCopy = {
  quizzes: {
    available: {
      title: "No quizzes available",
      description: "Assigned quizzes will appear here when they are ready.",
    },
    filtered: {
      title: "No quizzes match your filters",
      description: "Adjust your search or filters to see more quizzes.",
    },
    noData: {
      title: "No quiz data available",
      description: "Quiz details will appear here when they are available.",
    },
    managedEmpty: {
      title: "No quizzes yet",
      description: "Create your first quiz to start building assessments.",
    },
    managedFiltered: {
      title: "No quizzes match your filters",
      description: "Adjust the filters to find the quiz you need.",
    },
  },
  attempts: {
    none: {
      title: "No attempts yet",
      description: "Completed quizzes will appear here.",
    },
    reviewMissing: {
      title: "No attempt review data found",
      description: "This attempt review is not available right now.",
    },
  },
  practiceQuizzes: {
    none: {
      title: "No practice quizzes yet",
      description: "Create a practice quiz to start studying.",
    },
  },
  feedback: {
    mineEmpty: {
      title: "No feedback submitted yet",
      description:
        "Feedback you submit after reviewing quiz questions will appear here.",
    },
    disabled: {
      title: "Feedback is disabled",
      description: "This organization has disabled feedback.",
    },
    recentReplies: {
      title: "No recent replies yet",
      description: "Teacher replies to your feedback will appear here.",
    },
    adminEmpty: {
      title: "No feedback found",
      description: "Students will see this page once they submit feedback.",
    },
  },
  analytics: {
    noData: {
      title: "No analytics data yet",
      description: "Analytics will appear after students complete activities.",
    },
  },
  flashcards: {
    noDecks: {
      title: "No decks available yet",
      description:
        "Assigned flashcard decks will appear here when they are ready.",
    },
    noReviews: {
      title: "No flashcard reviews yet",
      description: "Review flashcards to start building progress data.",
    },
    nothingDue: {
      title: "Nothing due today",
      description: "You are caught up for now.",
    },
    sessionComplete: {
      title: "Session complete",
      description: "Your review session is complete.",
    },
    managedNone: {
      title: "No decks yet",
      description: "Create one to get started.",
    },
  },
  questions: {
    none: {
      title: "No questions found",
      description: "Create your first question or upload a CSV file.",
    },
  },
  subjects: {
    none: {
      title: "No subjects yet",
      description: "Add a new subject to get started.",
    },
  },
  organizations: {
    none: {
      title: "No organizations found",
      description: "You are not a member of any organizations yet.",
    },
  },
  topics: {
    none: {
      title: "No topics found",
      description: "Try adjusting your search to find topics.",
    },
    noQuestions: {
      title: "No questions in this topic",
      description: "Add existing questions to start building your topic.",
    },
    noUntaggedQuestions: {
      title: "No untagged questions",
      description: "All questions currently have at least one topic.",
    },
    notFound: {
      title: "Topic not found",
      description: "The topic you are looking for no longer exists.",
    },
  },
  permissions: {
    insufficient: {
      title: "Insufficient permissions",
      description: "Only organization admins or superusers can manage topics.",
    },
  },
} satisfies Record<string, Record<string, EmptyStateMessage>>
